import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { rfqPageDef } from '@/components/scm/scm-page-defs';

export default function ScmRfqPage() {
  return <ScmPageRenderer pageDef={rfqPageDef} />;
}
